import { render, staticRenderFns } from "./TireProductPromo.vue?vue&type=template&id=5bbdf23f"
import script from "./TireProductPromo.vue?vue&type=script&lang=ts"
export * from "./TireProductPromo.vue?vue&type=script&lang=ts"
import style0 from "./TireProductPromo.vue?vue&type=style&index=0&id=5bbdf23f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports